import UtilitiesCard from "@components/UtilitiesCard";
import usePageData from "@hooks/usePageData";

const Utilities = () => {
  const utilitiesData =
    usePageData(
      "$.page.data.right_sections.data[?(@.attributes.key=='utilities')]"
    )[0]?.attributes || {};

  return (
    <UtilitiesCard
      title={utilitiesData.title}
      utilitiesData={utilitiesData?.content?.[0]?.data || []}
    />
  );
};

export default Utilities;
